const testimonials = [
  {
    name: "Robert K.",
    location: "Plymouth, MN",
    rating: 5,
    text: "I received notice of a client meeting in London with twelve days to prepare. My passport had expired without me realizing it. Fast Passport Center processed my renewal in four business days. I made my flight and closed the deal. Their document review actually caught a signature issue I would have missed.",
    service: "Passport Renewal",
  },
  {
    name: "The Martinez Family",
    location: "Plymouth, MN",
    rating: 5,
    text: "We planned a Mediterranean cruise for our family of five and discovered two weeks before departure that our youngest daughter's passport was expired. Fast Passport Center walked us through the child passport process, reviewed our parental consent forms, and got her passport back in six business days. We made our cruise with a day to spare.",
    service: "Child Passport",
  },
  {
    name: "Dr. Lisa Chen",
    location: "Medical Professional, Plymouth",
    rating: 5,
    text: "I was invited to present at a medical conference in Singapore with three weeks notice. My passport had expired during COVID when I was not traveling. Fast Passport Center had my renewal processed and delivered in five business days. Their professional review gave me confidence everything was correct.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (<i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>))}
    </div>
  );
}

export default function PlymouthMNTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Plymouth &amp; Western Metro Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Plymouth, Wayzata, and Hennepin County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}